"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[54972],{

/***/ 88737:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41120);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(75154);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22318);



function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var useStyles = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(theme) {
    var _obj;
    return (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        root: (_obj = {
            display: 'flex',
            flexWrap: 'wrap',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
            minHeight: 70,
            padding: theme.spacing(4, 2),
            borderRadius: 6,
            background: theme.palette.primaryTransparent.light
        }, _defineProperty(_obj, theme.breakpoints.up('lg'), {
            flexDirection: 'row',
            justifyContent: 'space-between',
            textAlign: 'left',
            minHeight: 100,
            height: '100%',
            padding: theme.spacing(4, 4),
            borderRadius: theme.shape.borderRadius
        }), _defineProperty(_obj, '.MuiGrid-grid-md-4 &', {
            height: 'auto',
            padding: theme.spacing(1, 2),
            margin: theme.spacing(2, 0, 3)
        }), _obj),
        media: _defineProperty({
            margin: theme.spacing(0, 0, 2),
            '&>img': {
                display: 'block',
                maxWidth: 60
            }
        }, theme.breakpoints.up('lg'), {
            margin: 0,
            paddingRight: theme.spacing(5),
            '&>img': {
                maxWidth: 60
            }
        }),
        text: {
            flex: 1
        },
        richText: {
            '& p, & ul, & ol': {
                margin: 0
            },
            '& a': {
                color: 'currentColor',
                textDecoration: 'underline',
                '&:hover, &:focus': {
                    textDecoration: 'none'
                }
            }
        },
        rootCenter: _defineProperty({}, theme.breakpoints.up('lg'), {
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center'
        }),
        mediaCenter: {
            margin: theme.spacing(0, 0, 2),
            paddingRight: 0
        },
        commitmentImage: {
            width: '60px'
        }
    });
});
var Commitment = function(props) {
    var classes = useStyles(props);
    var icon = props.icon, title = props.title, desc = props.desc, center = props.center;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: center ? "commitment ".concat(classes.rootCenter, " ").concat(classes.root) : "commitment ".concat(classes.root),
        children: [
            icon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: center ? "commitment__media ".concat(classes.mediaCenter, " ").concat(classes.media) : "commitment__media ".concat(classes.media),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: icon,
                    alt: "",
                    className: classes.commitmentImage
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "commitment__text ".concat(classes.text),
                children: [
                    title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        variant: "h3",
                        component: "p",
                        className: 'commitment__title',
                        children: title
                    }),
                    desc && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        variant: "body1",
                        component: "div",
                        className: "commitment__desc ".concat(classes.richText),
                        children: desc
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Commitment);


/***/ }),

/***/ 54972:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Shop_Catalog; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/makeStyles.js
var makeStyles = __webpack_require__(41120);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/createStyles.js + 1 modules
var createStyles = __webpack_require__(75154);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/useTheme.js
var useTheme = __webpack_require__(8920);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(63457);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Grid/Grid.js
var Grid = __webpack_require__(41749);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/FormControlLabel/FormControlLabel.js
var FormControlLabel = __webpack_require__(30553);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Checkbox/Checkbox.js + 3 modules
var Checkbox = __webpack_require__(80797);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/FormControl/FormControl.js
var FormControl = __webpack_require__(64436);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Select/Select.js + 7 modules
var Select = __webpack_require__(24951);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/MenuItem/MenuItem.js
var MenuItem = __webpack_require__(85639);
// EXTERNAL MODULE: ./components/Shop/Shop.style.tsx
var Shop_style = __webpack_require__(45889);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(36456);
// EXTERNAL MODULE: ./components/Link/Link.tsx
var Link = __webpack_require__(31520);
// EXTERNAL MODULE: ./components/Button/Button.tsx
var Button = __webpack_require__(41107);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/esm/UnfoldMore.js
var UnfoldMore = __webpack_require__(94397);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/esm/KeyboardArrowRight.js
var KeyboardArrowRight = __webpack_require__(56251);
// EXTERNAL MODULE: ./node_modules/@datapunt/matomo-tracker-react/es/useMatomo.js + 1 modules
var useMatomo = __webpack_require__(86700);
// EXTERNAL MODULE: ./components/Commitment/Commitment.tsx
var Commitment = __webpack_require__(88737);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Tune.js
var Tune = __webpack_require__(68432);
// EXTERNAL MODULE: ./redux/actions/promotions.ts + 1 modules
var promotions = __webpack_require__(18919);
// EXTERNAL MODULE: ./components/Global/CMSText.tsx
var CMSText = __webpack_require__(94455);
;// CONCATENATED MODULE: ./components/ClassicSub/FlatRate.tsx







function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    var _obj, _obj1, _obj2;
    return (0,createStyles/* default */.Z)({
        root: (_obj = {
            textAlign: 'center',
            margin: theme.spacing(0, 0, 2),
            padding: theme.spacing(3, 2, 1),
            background: theme.palette.primaryTransparent.light,
            borderRadius: theme.shape.borderRadius
        }, _defineProperty(_obj, theme.breakpoints.up('lg'), {
            margin: theme.spacing(2, 0)
        }), _defineProperty(_obj, theme.breakpoints.down('md'), {
            padding: theme.spacing(2, 0.5, 1)
        }), _obj),
        title: {},
        subtitle: _defineProperty({}, theme.breakpoints.down('md'), {
            fontSize: theme.typography.caption.fontSize
        }),
        plans: (_obj1 = {
            display: 'flex',
            justifyContent: 'center',
            gap: theme.spacing(1)
        }, _defineProperty(_obj1, theme.breakpoints.down('xs'), {
            gap: theme.spacing(3)
        }), _defineProperty(_obj1, theme.breakpoints.up('lg'), {
            gap: theme.spacing(2)
        }), _obj1),
        plan: _defineProperty({
            margin: theme.spacing(4, 0, 2)
        }, theme.breakpoints.down('md'), {
            margin: theme.spacing(1, 0)
        }),
        priceRow: _defineProperty({
            display: 'flex',
            justifyContent: 'center',
            width: '100%',
            alignItems: 'baseline'
        }, theme.breakpoints.down('sm'), {}),
        priceNumber: _defineProperty({}, theme.breakpoints.down('md'), {
            fontSize: theme.typography.h3.fontSize
        }),
        priceFrequency: _defineProperty({}, theme.breakpoints.down('md'), {
            fontSize: theme.typography.caption.fontSize
        }),
        articles: {
            display: 'flex',
            justifyContent: 'center',
            width: '100%',
            alignItems: 'center'
        },
        numberArticles: (_obj2 = {
            display: 'inline-flex',
            padding: 0,
            width: '3ch',
            height: '3ch',
            lineHeight: 1,
            fontWeight: 700,
            textAlign: 'center',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: '50%',
            margin: theme.spacing(0.5),
            background: theme.palette.secondary.main,
            color: theme.palette.common.white
        }, _defineProperty(_obj2, theme.breakpoints.down('lg'), {
            fontSize: '80%'
        }), _defineProperty(_obj2, theme.breakpoints.down('md'), {
            fontSize: '60%'
        }), _obj2),
        articleText: {
            lineHeight: 1,
            textAlign: 'left'
        },
        numberText: _defineProperty({
            lineHeight: 1
        }, theme.breakpoints.down('lg'), {
            fontSize: '60%'
        })
    });
});
var mapStateToProps = function(state) {
    return {
        promotions: state.promotions
    };
};
var mapDispatchToProps = {
    getPromotions: promotions/* getPromotions */.Fh
};
var FlatRate = function(param) {
    var doc = param.doc, t = param.t, promotions = param.promotions, getPromotions1 = param.getPromotions;
    var ref9, ref1, ref2;
    (0,react.useEffect)(function() {
        if (!(promotions === null || promotions === void 0 ? void 0 : promotions.items) && !promotions.fetched && !promotions.loading) {
            getPromotions1();
        }
    }, []);
    var classes = useStyles();
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classes.root,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: 'h3',
                className: (0,clsx_m/* default */.Z)(classes.title, 'flatRate__subtitle'),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                    asText: true,
                    data: doc === null || doc === void 0 ? void 0 : (ref9 = doc.data) === null || ref9 === void 0 ? void 0 : ref9.title,
                    defaultText: t('texts:shop:classic_sub:our_rates')
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: 'body2',
                className: (0,clsx_m/* default */.Z)(classes.subtitle, 'flatRate__subtitle'),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                    asText: true,
                    data: doc === null || doc === void 0 ? void 0 : (ref1 = doc.data) === null || ref1 === void 0 ? void 0 : ref1.subtitle,
                    defaultText: t('texts:shop:classic_sub:adjustable_rate')
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classes.plans,
                children: promotions === null || promotions === void 0 ? void 0 : (ref2 = promotions.items) === null || ref2 === void 0 ? void 0 : ref2.map(function(promotion, index) {
                    /* Design is currently suited for 3 flatrates to show */ if (index < 3) {
                        var ref, ref3, ref4, ref5, ref6, ref7, ref8;
                        return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: classes.plan,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (0,clsx_m/* default */.Z)(classes.priceRow, 'flatRate__priceRow'),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            variant: 'h2',
                                            className: classes.priceNumber,
                                            children: (promotion.actions[0].configuration[Object.keys(promotions.items[0].actions[0].configuration)[0]].amount / 100).toFixed(0)
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                            variant: 'body2',
                                            className: classes.priceFrequency,
                                            children: [
                                                "€",
                                                t('texts:general:month_without_space')
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (0,clsx_m/* default */.Z)(classes.articles, 'flatRate__articles'),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                variant: 'body2',
                                                className: (0,clsx_m/* default */.Z)(classes.numberArticles, 'flatRate__articles__number'),
                                                noWrap: true,
                                                children: promotion.rules[0].configuration.to
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (0,clsx_m/* default */.Z)(classes.articleText, 'flatRate__articles__text'),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    variant: 'body2',
                                                    component: 'div',
                                                    className: classes.numberText,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                            asText: true,
                                                            data: ((ref = promotion === null || promotion === void 0 ? void 0 : promotion.rules[0]) === null || ref === void 0 ? void 0 : (ref3 = ref.configuration) === null || ref3 === void 0 ? void 0 : ref3.to) <= 1 ? doc === null || doc === void 0 ? void 0 : (ref4 = doc.data) === null || ref4 === void 0 ? void 0 : ref4.article_singular : doc === null || doc === void 0 ? void 0 : (ref5 = doc.data) === null || ref5 === void 0 ? void 0 : ref5.articles_plural,
                                                            defaultText: ((ref6 = promotion === null || promotion === void 0 ? void 0 : promotion.rules[0]) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.configuration) === null || ref7 === void 0 ? void 0 : ref7.to) <= 1 ? t('texts:shop:classic_sub:article') : t('texts:shop:classic_sub:articles')
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    variant: 'body2',
                                                    component: 'div',
                                                    className: classes.numberText,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                        asText: true,
                                                        data: doc === null || doc === void 0 ? void 0 : (ref8 = doc.data) === null || ref8 === void 0 ? void 0 : ref8.maximum,
                                                        defaultText: t('texts:shop:classic_sub:maximum')
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }, promotion.id));
                    }
                })
            })
        ]
    }));
};
/* harmony default export */ var ClassicSub_FlatRate = ((0,es/* connect */.$j)(mapStateToProps, mapDispatchToProps)(FlatRate));

// EXTERNAL MODULE: ./utils/scrollState.tsx
var utils_scrollState = __webpack_require__(75216);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./utils/useSticky.tsx
var useSticky = __webpack_require__(31494);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(31567);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/FilterListSharp.js
var FilterListSharp = __webpack_require__(98525);
// EXTERNAL MODULE: ./utils/constants.tsx
var constants = __webpack_require__(66026);
// EXTERNAL MODULE: ./redux/actions/products.ts
var products = __webpack_require__(86730);
// EXTERNAL MODULE: ./components/Shop/ProductListContainer.tsx + 2 modules
var ProductListContainer = __webpack_require__(59134);
// EXTERNAL MODULE: ./hooks/useShopSorting.ts
var useShopSorting = __webpack_require__(93795);
;// CONCATENATED MODULE: ./components/Shop/Catalog.tsx























function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function Catalog_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var Catalog_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return (0,createStyles/* default */.Z)({
        cta: Catalog_defineProperty({}, theme.breakpoints.down('md'), {}),
        filters: Catalog_defineProperty({}, theme.breakpoints.up('md'), {
            height: '100%'
        }),
        sticky: Catalog_defineProperty({}, theme.breakpoints.up('md'), {
            top: theme.spacing(2),
            position: 'sticky'
        }),
        filterList: {
            listStyle: 'none',
            display: 'flex',
            flexWrap: 'wrap',
            margin: 0,
            padding: 0
        },
        filterListItem: {
            margin: theme.spacing(0.5)
        },
        filterTitle: {
            flex: 1
        },
        catButton: {
            '&:disabled': {
                color: theme.palette.common.white
            }
        },
        onlyAvailable: {
            margin: theme.spacing(1, 0, 0, 0)
        },
        loaderContainer: {
            height: 500,
            width: '100%',
            alignItems: 'center',
            display: 'flex',
            justifyContent: 'center'
        },
        loadMoreBtnLoader: {
            width: '100%',
            alignItems: 'center',
            display: 'flex',
            justifyContent: 'center'
        },
        row: {
            display: 'inline-flex',
            justifyContent: 'space-between',
            width: '100%',
            marginTop: 50
        },
        rowCenter: {
            display: 'inline-flex',
            justifyContent: 'center',
            width: '100%',
            marginTop: 50
        },
        rowLeft: {
            display: 'inline-flex',
            justifyContent: 'left',
            alignItems: 'center',
            width: '100%'
        },
        countFilters: {
            marginLeft: theme.spacing(0.5),
            border: "1px solid ".concat(theme.palette.primary.main),
            borderRadius: 10,
            minWidth: 20,
            width: 20,
            height: 20,
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.common.white
        },
        alignCenter: {
            textAlign: 'center'
        },
        marginTop: {
            marginTop: theme.spacing(1)
        },
        catButtonColumn: {
            marginRight: theme.spacing(3)
        }
    });
});
var Catalog_mapStateToProps = function(state) {
    return {
        products: state.products,
        stock: state.stock,
        taxons: state.taxons
    };
};
var Catalog_mapDispatchToProps = {
    getProductsByTaxonsSlug: products/* getProductsByTaxonsSlug */.R2
};
var Catalog = function(param) {
    var categories = param.categories, products = param.products, stock = param.stock, taxons = param.taxons, setIsDrawerOpen = param.setIsDrawerOpen, settings = param.settings, isPack = param.isPack, classic_sub_text = param.classic_sub_text, shopData = param.shopData, hidePrice = param.hidePrice, loadMore = param.loadMore, basket = param.basket, currentPage = param.currentPage, handleNext = param.handleNext, handlePrev = param.handlePrev, handleLoadMore = param.handleLoadMore, handleSort = param.handleSort, takeback = param.takeback, _isDisplayedPrice = param.isDisplayedPrice, isDisplayedPrice = _isDisplayedPrice === void 0 ? true : _isDisplayedPrice, isLoadingProductsAndStocks = param.isLoadingProductsAndStocks, _hideFilters = param.hideFilters, hideFilters = _hideFilters === void 0 ? false : _hideFilters, _hideAvailableProductsOnly = param.hideAvailableProductsOnly, hideAvailableProductsOnly = _hideAvailableProductsOnly === void 0 ? false : _hideAvailableProductsOnly, _isSearch = param.isSearch, isSearch = _isSearch === void 0 ? false : _isSearch, mainData = param.mainData, productSettings = param.productSettings, getProductsByTaxonsSlug1 = param.getProductsByTaxonsSlug, sort = param.sort;
    var ref24, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20;
    var router = (0,next_router.useRouter)();
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var category = router === null || router === void 0 ? void 0 : (ref24 = router.query) === null || ref24 === void 0 ? void 0 : ref24.slug;
    var LayoutStyle = {
        isZwiterHandCategory: constants/* SECOND_HAND_TAXON_SLUGS.includes */.$X.includes(category === null || category === void 0 ? void 0 : category[0])
    };
    var shopClasses = (0,Shop_style/* default */.Z)(LayoutStyle);
    var classes = Catalog_useStyles();
    var theme = (0,useTheme/* default */.Z)();
    var layout = settings === null || settings === void 0 ? void 0 : settings.page_shop_layout;
    var isLG = (0,useMediaQuery/* default */.Z)(theme.breakpoints.up('lg'));
    var isMD = (0,useMediaQuery/* default */.Z)(theme.breakpoints.up('md'));
    var gridSpacing = isLG ? 4 : layout ? 1 : 2;
    var trackEvent = (0,useMatomo/* default */.Z)().trackEvent;
    var isClassicSub = "date_to_date" === 'classic_subscription';
    var ref21 = (0,react.useState)( true && (localStorage === null || localStorage === void 0 ? void 0 : localStorage.getItem('availableProductsOnly')) ? JSON.parse(localStorage === null || localStorage === void 0 ? void 0 : localStorage.getItem('availableProductsOnly')) : true), availableProductsOnly = ref21[0], setAvailableProductsOnly = ref21[1];
    var isSecondHandTaxon = constants/* isSecondHandOnly */.G7 === 'true' ? true : constants/* SECOND_HAND_TAXON_SLUGS.includes */.$X.includes(category === null || category === void 0 ? void 0 : category[0]);
    var loadingMoreProducts = (0,react.useMemo)(function() {
        return products.loadingCumulative || stock.loading || taxons.loading;
    }, [
        products.loadingCumulative,
        stock.loading,
        taxons.loading
    ]);
    var mergeFilterAndSort = shopData === null || shopData === void 0 ? void 0 : (ref1 = shopData.data) === null || ref1 === void 0 ? void 0 : ref1.merge_filter_and_sort;
    var ref22 = (0,useShopSorting/* useShopSorting */.P)(shopData, t), defaultSortValue = ref22.defaultSortValue, enableSorting = ref22.enableSorting, sortingOptions = ref22.sortingOptions, sortToString = ref22.sortToString, stringToSort = ref22.stringToSort;
    var selectSortingOptions = (0,react.useMemo)(function() {
        return [
            {
                value: '',
                label: t('texts:shop:sort')
            }, 
        ].concat(_toConsumableArray(sortingOptions));
    }, [
        t,
        sortingOptions
    ]);
    var sortingValue = (0,react.useMemo)(function() {
        var currentSort = sort || defaultSortValue;
        return sortToString(currentSort);
    }, [
        sort,
        defaultSortValue,
        sortToString
    ]);
    var handleSortChange = function(event) {
        var value = event.target.value;
        var slug = router.query.slug;
        trackEvent({
            category: 'Shop',
            action: "User sorting by ".concat(value, " in ").concat(slug)
        });
        var filtersFromUrl = router.query.filters;
        var sortValue = stringToSort(value);
        handleSort(sortValue);
        getProductsByTaxonsSlug1(Array.isArray(slug) ? slug[slug.length - 1] : slug, 48, 1, filtersFromUrl ? JSON.parse(filtersFromUrl) : [], null, null, isSecondHandTaxon, sortValue);
    };
    (0,react.useEffect)(function() {
        if (hideFilters) {
            setAvailableProductsOnly(settings === null || settings === void 0 ? void 0 : settings.search_only_available_products);
        } else {
            var ref;
            if (!(shopData === null || shopData === void 0 ? void 0 : (ref = shopData.data) === null || ref === void 0 ? void 0 : ref.show_only_available_checkbox)) {
                var ref23;
                setAvailableProductsOnly(shopData === null || shopData === void 0 ? void 0 : (ref23 = shopData.data) === null || ref23 === void 0 ? void 0 : ref23.show_only_available_products);
            }
        }
    }, [
        shopData === null || shopData === void 0 ? void 0 : (ref2 = shopData.data) === null || ref2 === void 0 ? void 0 : ref2.show_only_available_checkbox,
        shopData === null || shopData === void 0 ? void 0 : (ref3 = shopData.data) === null || ref3 === void 0 ? void 0 : ref3.show_only_available_products,
        hideFilters, 
    ]);
    var onlyAvailableText = /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
        asText: true,
        data: shopData === null || shopData === void 0 ? void 0 : (ref4 = shopData.data) === null || ref4 === void 0 ? void 0 : ref4.show_only_available_text,
        defaultText: t('texts:shop:availableOnly')
    });
    var scrollState = (0,utils_scrollState/* useScrollState */.M)();
    var isSticky = (0,useSticky/* useSticky */.A)(layout);
    var toggleAvailableProductsOnly = (0,react.useCallback)(function(isAvailableProductsOnly) {
        return function() {
            setAvailableProductsOnly(isAvailableProductsOnly);
            localStorage.setItem('availableProductsOnly', isAvailableProductsOnly.toString());
        };
    }, []);
    var filtersFromUrl1 = router.query.filters;
    var parsedFilters = filtersFromUrl1 ? JSON.parse(filtersFromUrl1) : [];
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        id: 'catalog',
        "data-product": isLoadingProductsAndStocks ? 'loading' : 'loaded',
        children: (!categories || (categories === null || categories === void 0 ? void 0 : (ref5 = categories.items) === null || ref5 === void 0 ? void 0 : (ref6 = ref5[0]) === null || ref6 === void 0 ? void 0 : ref6.children.length) !== 0) && (layout ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                container: true,
                spacing: gridSpacing,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                        item: true,
                        xs: 12,
                        md: 4,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: classes.filters,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    component: "p",
                                    variant: "h3",
                                    className: "shop-claim__title",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                        asText: true,
                                        data: shopData === null || shopData === void 0 ? void 0 : (ref7 = shopData.data) === null || ref7 === void 0 ? void 0 : ref7.titleshop,
                                        defaultText: t('texts:shop:titleshop')
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    component: "p",
                                    variant: "body1",
                                    color: "secondary",
                                    className: "shop-claim__desc",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                            data: shopData === null || shopData === void 0 ? void 0 : (ref8 = shopData.data) === null || ref8 === void 0 ? void 0 : ref8.shopdescription,
                                            defaultText: t('texts:shop:shopdescription')
                                        })
                                    })
                                }),
                                isMD && !isClassicSub && /*#__PURE__*/ (0,jsx_runtime.jsx)(Commitment/* default */.Z, {
                                    desc: (0,CMSText/* prismicText */.yz)(shopData === null || shopData === void 0 ? void 0 : (ref9 = shopData.data) === null || ref9 === void 0 ? void 0 : ref9.shippingdescription, t('shop:shippingdescription')),
                                    icon: (shopData === null || shopData === void 0 ? void 0 : (ref10 = shopData.data) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.shippingimage) === null || ref11 === void 0 ? void 0 : ref11.url) ? shopData === null || shopData === void 0 ? void 0 : (ref12 = shopData.data) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.shippingimage) === null || ref13 === void 0 ? void 0 : ref13.url : null
                                }),
                                isClassicSub && /*#__PURE__*/ (0,jsx_runtime.jsx)(ClassicSub_FlatRate, {
                                    doc: classic_sub_text,
                                    t: t
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                        item: true,
                        xs: 12,
                        md: 7,
                        lg: 8,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                (shopData === null || shopData === void 0 ? void 0 : (ref14 = shopData.data) === null || ref14 === void 0 ? void 0 : ref14.show_only_available_checkbox) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: classes.rowLeft,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: classes.catButtonColumn,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                                                size: "small",
                                                startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tune/* default */.Z, {}),
                                                variant: "outlined",
                                                color: "primary",
                                                onClick: function() {
                                                    return setIsDrawerOpen(true);
                                                },
                                                className: (0,clsx_m/* default */.Z)('shop-filters', shopClasses.shopFilters),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                            data: mergeFilterAndSort ? shopData === null || shopData === void 0 ? void 0 : (ref15 = shopData.data) === null || ref15 === void 0 ? void 0 : ref15.filter_and_sort : shopData === null || shopData === void 0 ? void 0 : (ref16 = shopData.data) === null || ref16 === void 0 ? void 0 : ref16.filter,
                                                            defaultText: mergeFilterAndSort ? t('texts:shop:filter_and_sort') : t('texts:shop:filter'),
                                                            asText: true
                                                        })
                                                    }),
                                                     true && parsedFilters.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: classes.countFilters,
                                                        children: parsedFilters === null || parsedFilters === void 0 ? void 0 : parsedFilters.length
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                                                control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                                    checked: availableProductsOnly,
                                                    onChange: toggleAvailableProductsOnly(!availableProductsOnly),
                                                    name: "availability_check",
                                                    "data-testid": 'availability_check'
                                                }),
                                                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    variant: 'body2',
                                                    children: onlyAvailableText
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductListContainer/* default */.Z, {
                                    products: products.items,
                                    loadMore: loadMore,
                                    availableProductsOnly: availableProductsOnly,
                                    shopData: shopData,
                                    settings: settings,
                                    hidePrice: hidePrice,
                                    basket: basket,
                                    takeback: takeback,
                                    isDisplayedPrice: isDisplayedPrice,
                                    isLoadingProductsAndStocks: isLoadingProductsAndStocks,
                                    isSearch: isSearch,
                                    mainData: mainData,
                                    productSettings: productSettings,
                                    isSecondHandTaxon: isSecondHandTaxon,
                                    currentPage: currentPage,
                                    handlePrev: handlePrev,
                                    handleNext: handleNext,
                                    handleLoadMore: handleLoadMore,
                                    loadingMoreProducts: loadingMoreProducts
                                })
                            ]
                        })
                    })
                ]
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: 'spy'
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (0,clsx_m/* default */.Z)('sticky-bar', 'sticky-bar--shop', shopClasses.stickyBar, isSticky && [
                        shopClasses.stickyBarSticked,
                        'sticky-bar--sticked', 
                    ], scrollState.showOnTop && [
                        shopClasses.stickyBarTop,
                        'sticky-bar--top', 
                    ], scrollState.showOnScrollUp && [
                        shopClasses.stickyBarScrollUp,
                        'sticky-bar--scrollup', 
                    ]),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (0,clsx_m/* default */.Z)('shop-menu', 'shop-menu--products', shopClasses.shopMenu),
                                children: [
                                    !hideFilters && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                                        size: "small",
                                        startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tune/* default */.Z, {}),
                                        variant: "outlined",
                                        color: "primary",
                                        onClick: function() {
                                            return setIsDrawerOpen(true);
                                        },
                                        className: (0,clsx_m/* default */.Z)('shop-filters', shopClasses.shopFilters),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                    data: mergeFilterAndSort ? shopData === null || shopData === void 0 ? void 0 : (ref17 = shopData.data) === null || ref17 === void 0 ? void 0 : ref17.filter_and_sort : shopData === null || shopData === void 0 ? void 0 : (ref18 = shopData.data) === null || ref18 === void 0 ? void 0 : ref18.filter,
                                                    defaultText: mergeFilterAndSort ? t('texts:shop:filter_and_sort') : t('texts:shop:filter'),
                                                    asText: true
                                                })
                                            }),
                                             true && (parsedFilters === null || parsedFilters === void 0 ? void 0 : parsedFilters.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: classes.countFilters,
                                                children: parsedFilters === null || parsedFilters === void 0 ? void 0 : parsedFilters.length
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (0,clsx_m/* default */.Z)(shopClasses.shopMenuRightControls, 'shop-menu__right-controls__container'),
                                        children: [
                                            enableSorting && !mergeFilterAndSort && /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormControl/* default */.Z, {
                                                variant: "outlined",
                                                className: (0,clsx_m/* default */.Z)('shop-menu__right-controls', shopClasses.shopMenuRightControls, 'shop-menu__sort'),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (0,clsx_m/* default */.Z)('shop-menu__right-controls__icon-container', shopClasses.shopMenuRightControlsIconContainer),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterListSharp/* default */.Z, {
                                                            className: "shop-menu__right-controls__icon"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Select/* default */.Z, {
                                                        className: "shop-menu__sort-input",
                                                        defaultValue: '',
                                                        displayEmpty: true,
                                                        IconComponent: UnfoldMore/* default */.Z,
                                                        onChange: handleSortChange,
                                                        value: sortingValue,
                                                        children: selectSortingOptions.map(function(option) {
                                                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                                                                value: option.value,
                                                                children: option.label
                                                            }, option.value);
                                                        })
                                                    })
                                                ]
                                            }),
                                            isPack && !isSticky && !LayoutStyle.isZwiterHandCategory && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (0,clsx_m/* default */.Z)('shop-menu__cta', shopClasses.shopMenuCta),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                                    href: "/packs",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                            className: (0,clsx_m/* default */.Z)('shop-menu__cta-link', classes.cta),
                                                            variant: "outlined",
                                                            component: "span",
                                                            onClick: function() {
                                                                return trackEvent({
                                                                    category: 'Shop',
                                                                    href: '/packs',
                                                                    action: 'Shop to packs'
                                                                });
                                                            },
                                                            size: "small",
                                                            color: "primary",
                                                            endIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(KeyboardArrowRight/* default */.Z, {}),
                                                            children: (0,CMSText/* prismicText */.yz)(shopData === null || shopData === void 0 ? void 0 : (ref19 = shopData.data) === null || ref19 === void 0 ? void 0 : ref19.shop_to_packs_button, t('texts:shop:shop_to_packs_button'))
                                                        })
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            !hideAvailableProductsOnly && (shopData === null || shopData === void 0 ? void 0 : (ref20 = shopData.data) === null || ref20 === void 0 ? void 0 : ref20.show_only_available_checkbox) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "onlyAvailable ".concat(classes.onlyAvailable),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                                    control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                        checked: availableProductsOnly,
                                        onChange: toggleAvailableProductsOnly(!availableProductsOnly),
                                        name: "availability_check",
                                        "data-testid": 'availability_check',
                                        className: 'onlyAvailable__check'
                                    }),
                                    label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: 'caption',
                                        className: 'onlyAvailable__label',
                                        children: onlyAvailableText
                                    })
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductListContainer/* default */.Z, {
                    products: products.items,
                    loadMore: loadMore,
                    availableProductsOnly: availableProductsOnly,
                    shopData: shopData,
                    settings: settings,
                    hidePrice: hidePrice,
                    basket: basket,
                    takeback: takeback,
                    isDisplayedPrice: isDisplayedPrice,
                    isLoadingProductsAndStocks: isLoadingProductsAndStocks,
                    isSearch: isSearch,
                    mainData: mainData,
                    productSettings: productSettings,
                    isSecondHandTaxon: isSecondHandTaxon,
                    currentPage: currentPage,
                    handlePrev: handlePrev,
                    handleNext: handleNext,
                    handleLoadMore: handleLoadMore,
                    loadingMoreProducts: loadingMoreProducts
                })
            ]
        }))
    }));
};
/* harmony default export */ var Shop_Catalog = ((0,es/* connect */.$j)(Catalog_mapStateToProps, Catalog_mapDispatchToProps)(Catalog));


/***/ }),

/***/ 93795:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ useShopSorting; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _components_Global_CMSText__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94455);


function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var useShopSorting = function(shopData, t) {
    var ref17, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    var ref9 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        var ref, ref10, ref11, ref12, ref13, ref14, ref15, ref16;
        return [
            (shopData === null || shopData === void 0 ? void 0 : (ref = shopData.data) === null || ref === void 0 ? void 0 : ref.sort_by_price_asc) || (shopData === null || shopData === void 0 ? void 0 : (ref10 = shopData.data) === null || ref10 === void 0 ? void 0 : ref10.sort_by_date_asc) || (shopData === null || shopData === void 0 ? void 0 : (ref11 = shopData.data) === null || ref11 === void 0 ? void 0 : ref11.sort_by_price_desc) || (shopData === null || shopData === void 0 ? void 0 : (ref12 = shopData.data) === null || ref12 === void 0 ? void 0 : ref12.sort_by_date_desc),
            shopData === null || shopData === void 0 ? void 0 : (ref13 = shopData.data) === null || ref13 === void 0 ? void 0 : ref13.sort_by_price_asc,
            shopData === null || shopData === void 0 ? void 0 : (ref14 = shopData.data) === null || ref14 === void 0 ? void 0 : ref14.sort_by_price_desc,
            shopData === null || shopData === void 0 ? void 0 : (ref15 = shopData.data) === null || ref15 === void 0 ? void 0 : ref15.sort_by_date_asc,
            shopData === null || shopData === void 0 ? void 0 : (ref16 = shopData.data) === null || ref16 === void 0 ? void 0 : ref16.sort_by_date_desc, 
        ];
    }, [
        shopData === null || shopData === void 0 ? void 0 : (ref17 = shopData.data) === null || ref17 === void 0 ? void 0 : ref17.sort_by_price_asc,
        shopData === null || shopData === void 0 ? void 0 : (ref1 = shopData.data) === null || ref1 === void 0 ? void 0 : ref1.sort_by_date_asc,
        shopData === null || shopData === void 0 ? void 0 : (ref2 = shopData.data) === null || ref2 === void 0 ? void 0 : ref2.sort_by_price_desc,
        shopData === null || shopData === void 0 ? void 0 : (ref3 = shopData.data) === null || ref3 === void 0 ? void 0 : ref3.sort_by_date_desc, 
    ]), enableSorting = ref9[0], enableSortingByPriceAsc = ref9[1], enableSortingByPriceDesc = ref9[2], enableSortingByDateAsc = ref9[3], enableSortingByDateDesc = ref9[4];
    var defaultSortValue = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        var ref;
        var defaultSorting = shopData === null || shopData === void 0 ? void 0 : (ref = shopData.data) === null || ref === void 0 ? void 0 : ref.default_sorting_value;
        if (!defaultSorting) return null;
        // Map default_sorting_value to sort object format
        var sortMapping = {
            sort_by_price_asc: {
                price: 'ASC'
            },
            sort_by_price_desc: {
                price: 'DESC'
            },
            sort_by_date_asc: {
                date: 'ASC'
            },
            sort_by_date_desc: {
                date: 'DESC'
            }
        };
        var mappedSort = sortMapping[defaultSorting];
        if (!mappedSort) return null;
        // Check if the corresponding enable flag is true
        var enableFlags = {
            sort_by_price_asc: enableSortingByPriceAsc,
            sort_by_price_desc: enableSortingByPriceDesc,
            sort_by_date_asc: enableSortingByDateAsc,
            sort_by_date_desc: enableSortingByDateDesc
        };
        if (enableFlags[defaultSorting]) {
            return mappedSort;
        }
        return null;
    }, [
        shopData === null || shopData === void 0 ? void 0 : (ref4 = shopData.data) === null || ref4 === void 0 ? void 0 : ref4.default_sorting_value,
        enableSortingByPriceAsc,
        enableSortingByPriceDesc,
        enableSortingByDateAsc,
        enableSortingByDateDesc, 
    ]);
    var sortToString = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(sort) {
        var ref;
        if (!sort) return '';
        var key = (ref = Object.keys(sort)) === null || ref === void 0 ? void 0 : ref[0];
        return key ? "".concat(key, ":").concat(sort[key]) : '';
    }, []);
    var stringToSort = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(value) {
        if (!value) return null;
        var ref = _slicedToArray(value.split(':'), 2), sortField = ref[0], sortDirection = ref[1];
        if (!sortField || !sortDirection) return null;
        return _defineProperty({}, sortField, sortDirection);
    }, []);
    var sortingOptions = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        if (!t) return [];
        var options = [];
        if (enableSortingByPriceAsc) {
            var ref;
            options.push({
                value: 'price:ASC',
                label: (0,_components_Global_CMSText__WEBPACK_IMPORTED_MODULE_1__/* .prismicText */ .yz)(shopData === null || shopData === void 0 ? void 0 : (ref = shopData.data) === null || ref === void 0 ? void 0 : ref.sort_by_price_asc_label, t('texts:shop:sort_by_price_asc'))
            });
        }
        if (enableSortingByPriceDesc) {
            var ref18;
            options.push({
                value: 'price:DESC',
                label: (0,_components_Global_CMSText__WEBPACK_IMPORTED_MODULE_1__/* .prismicText */ .yz)(shopData === null || shopData === void 0 ? void 0 : (ref18 = shopData.data) === null || ref18 === void 0 ? void 0 : ref18.sort_by_price_desc_label, t('texts:shop:sort_by_price_desc'))
            });
        }
        if (enableSortingByDateDesc) {
            var ref19;
            options.push({
                value: 'date:DESC',
                label: (0,_components_Global_CMSText__WEBPACK_IMPORTED_MODULE_1__/* .prismicText */ .yz)(shopData === null || shopData === void 0 ? void 0 : (ref19 = shopData.data) === null || ref19 === void 0 ? void 0 : ref19.sort_by_date_desc_label, t('texts:shop:sort_by_date_desc'))
            });
        }
        if (enableSortingByDateAsc) {
            var ref20;
            options.push({
                value: 'date:ASC',
                label: (0,_components_Global_CMSText__WEBPACK_IMPORTED_MODULE_1__/* .prismicText */ .yz)(shopData === null || shopData === void 0 ? void 0 : (ref20 = shopData.data) === null || ref20 === void 0 ? void 0 : ref20.sort_by_date_asc_label, t('texts:shop:sort_by_date_asc'))
            });
        }
        return options;
    }, [
        t,
        shopData === null || shopData === void 0 ? void 0 : (ref5 = shopData.data) === null || ref5 === void 0 ? void 0 : ref5.sort_by_price_asc_label,
        shopData === null || shopData === void 0 ? void 0 : (ref6 = shopData.data) === null || ref6 === void 0 ? void 0 : ref6.sort_by_price_desc_label,
        shopData === null || shopData === void 0 ? void 0 : (ref7 = shopData.data) === null || ref7 === void 0 ? void 0 : ref7.sort_by_date_asc_label,
        shopData === null || shopData === void 0 ? void 0 : (ref8 = shopData.data) === null || ref8 === void 0 ? void 0 : ref8.sort_by_date_desc_label,
        enableSortingByPriceAsc,
        enableSortingByPriceDesc,
        enableSortingByDateAsc,
        enableSortingByDateDesc, 
    ]);
    return {
        defaultSortValue: defaultSortValue,
        enableSorting: enableSorting,
        enableSortingByPriceAsc: enableSortingByPriceAsc,
        enableSortingByPriceDesc: enableSortingByPriceDesc,
        enableSortingByDateAsc: enableSortingByDateAsc,
        enableSortingByDateDesc: enableSortingByDateDesc,
        sortingOptions: sortingOptions,
        sortToString: sortToString,
        stringToSort: stringToSort
    };
};


/***/ }),

/***/ 31494:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ useSticky; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8920);


var useSticky = function(layout) {
    var theme = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isSticky = ref[0], setIsSticky = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var isMounted = true;
        var observer;
        var handleSticky = function() {
            if ( true && !layout && isMounted) {
                var spyEl = document.querySelector('.spy');
                var handler = function(entries) {
                    if (!entries[0].isIntersecting) {
                        setIsSticky(true);
                    } else {
                        setIsSticky(false);
                    }
                };
                var observeOpts = {
                    rootMargin: "-".concat(theme.spacing(4), "px 0px 0px 0px"),
                    threshold: 0.5
                };
                // create the observer
                observer = new IntersectionObserver(handler, observeOpts);
                observer.observe(spyEl);
            }
        };
        handleSticky();
        return function() {
            isMounted = false;
            observer === null || observer === void 0 ? void 0 : observer.disconnect();
        };
    }, [
        "object",
        layout
    ]);
    return isSticky;
};


/***/ })

}]);